module.exports = __webpack_public_path__ + "static/media/graphic-letter-x-round-1-st.96d9bfaf.svg";